<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header ref="header" slot="header" @query="getData">
        <template slot-scope="{ form }">
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="exportFile(form)"
            v-if="allow('E')"
          >
            <i class="el-icon-folder-opened"></i>
            {{ $l('INDEX.btn_export') || '导出' }}
          </b-button>
        </template>
      </page-header>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'admin-reportSampleStorage' }"
      :exportOptions="{
        params: { ...chooseTemplateOptions.params },
      }"
    />
  </div>
</template>
<script>
import PageMain from './main.vue'
import PageHeader from './header.vue'
import BaseTable from '@/mixins/base-table'
import chooseTemplate from '@/views/backstage/components/choose-template'
export default {
  components: { PageMain, PageHeader, chooseTemplate },
  mixins: [BaseTable],
  data() {
    return {
      loading: false,
      usePage: true,
      chooseTemplateOptions: { visible: false, params: {} },
    }
  },

  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .billStockInDetailReportListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    async exportFile(searchForm = {}) {
      this.chooseTemplateOptions = {
        visible: true,
        params: {
          ...searchForm,
        },
      }
    },
  },
}
</script>
